import { render, staticRenderFns } from "./SchoolSet.vue?vue&type=template&id=e86bbd04"
import script from "./SchoolSet.vue?vue&type=script&lang=js"
export * from "./SchoolSet.vue?vue&type=script&lang=js"
import style0 from "./SchoolSet.vue?vue&type=style&index=0&id=e86bbd04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports